import React, { Component, Fragment } from 'react';
import { Row, Col, Button, Label } from "reactstrap";
import { inject, observer } from 'mobx-react';
import { IconeInformacao } from '../../comum/components/Icones';
import * as moment from 'moment';
import ListaServicos from './ListaServicos';
import Tooltip from '../../comum/components/Tooltip';
import Card from '../../comum/components/Card';
import DetalhesImpBl from './DetalhesImpBl';
import InputSelect from '../../comum/tables/components/inputs/InputSelect';
import { toJS } from 'mobx';
import { E_TIPO_CLIENTE, E_TIPO_TELA } from '../stores/Enum';
import InputRangeDate from '../../comum/tables/components/inputs/InputRangeDate';
import AddServicosAcessorios from './AddServicosAcessorios';
import AddServicosQtdVariavel from './AddServicosQtdVariavel';
import { LoadingWhapper } from '../../comum/loading/components';

@inject("store")
@observer
export default class DetalhesImportacao extends Component {
    constructor(props) {
        super(props);

        this.viewStore = this.props.controllers.viewStore;
        this.dataStore = this.props.controllers.dataStore;
        this.filterStore = this.props.controllers.filterStore;
        this.impStore = this.props.controllers.impStore;
        this.modalStore = this.props.store.modalStoreCustom;
    }

    componentDidMount() {
        this.viewStore.simulacaoAtiva = true;
        this.impStore.fecthOptions(this.filterStore.tipoCliente);

        this.impStore.setDefaultValuesByTipoCliente(this.filterStore.tipoCliente);
    }

    handleGerarServicosImp = async () => {
        if (this.viewStore.servicosAtivo){
            this.impStore.resetarServicos();
            this.viewStore.servicosAtivo = false;
        }
        else {
            this.viewStore.servicosAtivo = true;

            const { error, message } = await this.impStore.gerarServicos(this.filterStore.filters);
    
            if (error) {
                this.viewStore.servicosAtivo = false;
                if (message) this.modalStore.openNewConfigurableModal('Alerta!', {
                    body: <p>{message}</p>,
                    hideCancel: true,
                })
            }
        }
    }

    handleConfirm = async () => {
        const modalSelect = this.modalStore.openNewConfigurableModal('Atenção', {
            body: <p>Aguarde por favor!</p>,
            loading: true,
            hideCancel: true
        });

        const { status, title, message, dadosModalidade } = await this.impStore.calcularSimulacao(this.filterStore.filters);
        
        if (status == 200) {
            this.dataStore.dadosModalidade = dadosModalidade;
            this.viewStore.alteraTela(E_TIPO_TELA.ResultadoSimulacao);
        }
        
        modalSelect.appendConfigurableModal({
            title,
            body: <p dangerouslySetInnerHTML={{__html: message}}></p>,
            loading: false,
            hideCancel: true,
        });
    }

    render() {
        const { DataEntrada, DataSaida, TipoRegime, TipoDeclaracao, Bls, ManualMecanizada, ParcialTotal, Erros } = this.impStore.data.value;
        
        const temArmador = this.filterStore.tipoCliente == E_TIPO_CLIENTE.Armador;

        const ultimoDiaAno = moment().month() == 11 ? moment().add(1, 'year').endOf('year') : moment().endOf('year');
        const primeiroDiaAno = moment().startOf('year');
        
        return (
            <Col xs={12} sm={12} md={12} lg={12} xl={12} className="mt-3">
                <Row className="d-flex align-items-baseline justify-content-between px-3">
                    <h4>Simulação</h4>
                    <Button className="mb-1 btn-com-bordas-primary" onClick={this.handleGerarServicosImp} > 
                        {this.viewStore.servicosAtivo ? "Editar Serviços" : "Gerar Serviços"}                        
                    </Button>
                </Row>
                <Card className="">
                    <Row className="w-100">
                        <InputRangeDate xs={12} sm={12} md={6} lg={4} xl={4}
                            className={'pr-1'}
                            title={this.filterStore.tipoCliente == E_TIPO_CLIENTE.Carga ? 
                                "Data Inicial - Saída" :
                                "Data Entrada - Saída"
                            }
                            required={true}
                            error={Erros['DataEntrada'] || Erros['DataSaida']}
                            onChangeStart={(value)=>this.impStore.setItem('DataEntrada', value)}
                            onChangeEnd={(value)=>this.impStore.setItem('DataSaida', value)}
                            startDate={DataEntrada}
                            endDate={DataSaida}
                            isOutsideRange={day => !day.isAfter(primeiroDiaAno) || !day.isBefore(ultimoDiaAno)} 
                            disabled={this.viewStore.servicosAtivo}
                        />
                        <Tooltip 
                            tooltipText={(
                                <Fragment>
                                    Entrada: Data de atracação do navio. <br/> <br/>
                                    Saída: Data de retirada do container.'
                                </Fragment>
                            )} 
                            containerClassName="align-content-center"
                            style={{ width: 'max-content', marginTop: '-90px', marginLeft: '-80px', textAlign: 'left' }} bottom >
                            <IconeInformacao className="card-colorido--icone mt-1" />
                            {(this.impStore.data.error) && <Label className="label-danger">{this.impStore.data.error}</Label>}
                        </Tooltip>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="pr-0">
                            <Row className="w-100">
                                {!temArmador && (
                                    <InputSelect xs={12} sm={12} md={this.impStore.showOptionPier ? 2 : 3} lg={this.impStore.showOptionPier ? 2 : 3} xl={this.impStore.showOptionPier ? 2 : 3}
                                        title="Tipo de Regime"
                                        name="TipoRegime"
                                        options={toJS(this.impStore.opcoesTipoRegimeImp.value)}
                                        onChange={opt => this.impStore.setItem('TipoRegime', opt ? opt.value : null)}
                                        value={TipoRegime ? this.impStore.opcoesTipoRegimeImp.value.find(o => o.value == TipoRegime) : null}
                                        loading={this.impStore.opcoesTipoRegimeImp.loading}
                                        disabled={this.impStore.hasBls}
                                    />                        
                                )}
                                {this.impStore.showOptionPier &&
                                    <Fragment>
                                        <InputSelect xs={12} sm={12} md={2} lg={2} xl={2}
                                            title="Manual/Mecaniz."
                                            name="ManualMecanizada"
                                            options={toJS(this.impStore.opcoesManualMecanizadaImp.value)}
                                            onChange={opt => this.impStore.setItem('ManualMecanizada', opt ? opt.value : null)}
                                            value={ManualMecanizada ? this.impStore.opcoesManualMecanizadaImp.value.find(o => o.value == ManualMecanizada) : null}
                                            loading={this.impStore.opcoesManualMecanizadaImp.loading}
                                            disabled={this.impStore.hasBls}
                                        />
                                        <InputSelect xs={12} sm={12} md={2} lg={2} xl={2}
                                            title="Parcial/Total"
                                            name="ParcialTotal"
                                            options={toJS(this.impStore.opcoesParcialTotalImp.value)}
                                            onChange={opt => this.impStore.setItem('ParcialTotal', opt ? opt.value : null)}
                                            value={ParcialTotal ? this.impStore.opcoesParcialTotalImp.value.find(o => o.value == ParcialTotal) : null}
                                            loading={this.impStore.opcoesParcialTotalImp.loading}
                                            disabled={this.impStore.hasBls || this.impStore.showOptionPier}
                                        />
                                    </Fragment>
                                }
                                {!temArmador && (
                                    <Fragment>
                                        <InputSelect xs={12} sm={12} md={this.impStore.showOptionPier ? 3 : 4} lg={this.impStore.showOptionPier ? 3 : 4} xl={this.impStore.showOptionPier ? 3 : 4}
                                            title="Tipo de Declaração"
                                            name="TipoDeclaracao"
                                            options={this.impStore.opcoesTipoDeclaracaoFiltradas}
                                            onChange={opt => this.impStore.setItem('TipoDeclaracao', opt ? opt.value : null)}
                                            value={TipoDeclaracao ? this.impStore.opcoesTipoDeclaracaoImp.value.find(o => o.value == TipoDeclaracao) : null}
                                            loading={this.impStore.opcoesTipoDeclaracaoImp.loading}
                                            disabled={this.impStore.hasBls}
                                        />
                                        <Col xs={12} sm={12} md={2} lg={2} xl={2} className="px-0 pt-1">
                                            {this.impStore.canAddNewBls && (
                                                <Button 
                                                    className="mb-1 mt-4 btn-com-bordas-primary ml-3" 
                                                    onClick={() => this.impStore.resetBls()}
                                                    disabled={this.viewStore.servicosAtivo}
                                                >
                                                    Editar                               
                                                </Button>
                                            )}
                                        </Col>
                                    </Fragment>
                                )}
                            </Row>
                        </Col>
                    </Row>
                    {Bls.length > 0 && (
                        <Fragment>
                            {!temArmador && (
                                <Row className="d-flex align-items-baseline justify-content-between px-3 mb-2">
                                    <h4 style={{borderBottom:'2px solid #001C43', maxWidth: 'max-content'}}>{this.impStore.showOptionPier ? 'BL' : 'Itens da BL'}</h4>
                                </Row>
                            )}
                            {Bls.map((bl, index) => (
                                <Fragment key={index}>
                                    <DetalhesImpBl
                                        controllers={this.props.controllers}
                                        bl={bl}
                                        index={index}
                                    />
                                </Fragment>                            
                            ))}
                        </Fragment>
                    )}
                    <Row className="d-flex align-items-center">
                        <Button className="ml-3 mt-3 btn-com-bordas-primary" onClick={() => this.impStore.addBl()} 
                            disabled={this.viewStore.servicosAtivo || !this.impStore.canAddNewBls}>
                            {`+ Adicionar ${temArmador ? 'Item' : 'BL'}`}
                        </Button>
                    </Row>
                </Card>
                {this.viewStore.servicosAtivo &&
                    <Fragment>
                        <Row className="d-flex align-items-baseline px-3 mt-4">
                            <h4>Serviços</h4>
                            <Col className="d-flex justify-content-end">
                                <AddServicosAcessorios 
                                    className="mb-1 btn-com-bordas-primary" 
                                    controllers={this.props.controllers}
                                    tipoTela={E_TIPO_TELA.Importacao}
                                    items={this.impStore.getAllItems()}
                                >
                                    + Serviços Acessórios
                                </AddServicosAcessorios>
                                <AddServicosQtdVariavel
                                    controllers={this.props.controllers}
                                    tipoTela={E_TIPO_TELA.Importacao}
                                />
                            </Col>
                        </Row>
                        <Card className="px-3 pb-5">
                            <LoadingWhapper loading={this.impStore.loadingServicos} >
                                <ListaServicos dataStore={this.impStore}/>
                            </LoadingWhapper>
                        </Card>
                        {this.impStore.servicos.length > 0 &&
                            <div className="d-flex flex-column align-items-center justify-content-end mt-3">
                                <Col xs={12} sm={12} md={3} lg={3} xl={3} className="d-flex flex-row align-items-end">
                                    <Button size="lg" className="btn-com-bordas-primary btn-filtrar" 
                                        block
                                        onClick={this.handleConfirm}
                                    >
                                        Simular
                                    </Button>
                                </Col>
                            </div>
                        }
                    </Fragment>
                }
            </Col>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/components/DetalhesImportacao.js